import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    invalidTargetProject: string;
    loading: (count: number) => string;
    errorMessage: (count: number) => string;
    successMessage: (count: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error shown when a move crosses between regular and managed project storage, in either direction. */
            invalidTargetProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useSyncMoveAssets.invalidTargetProject?c=29ywe52sgopsz", defaultMessage: "Moving assets between regular and managed projects isn''t supported yet." }));
                },
                enumerable: true,
                configurable: true
            },
            loading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useSyncMoveAssets.loading?c=3ed8xuo9fx011", defaultMessage: "{count, plural, one {Moving {count} item\u2026} other {Moving {count} items\u2026}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useSyncMoveAssets.errorMessage?c=x393tbvp584", defaultMessage: "{count, plural, one {Couldn''t move {count} item} other {Couldn''t move {count} items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            successMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useSyncMoveAssets.successMessage?c=bw89r66ztf4e", defaultMessage: "{count, plural, one {Moved {count} item} other {Moved {count} items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
